import React from 'react';

import { Header } from '@zapier/product-dev-platform';
import { getGravatarUrl } from '@zapier/common-utils';

import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';
import {
  useAvroEvent,
  useActiveProfile,
  useRouter,
} from 'app/developer-v3/hooks';

import {
  emitUserEventOptionClicked,
  getCtaLinks,
  getNavLinks,
  getUserLinks,
} from './utils';

function PlatformHeader() {
  const {
    emitPartnerUserInteractionEvent,
    emitUserInteractionEvent,
  } = useAvroEvent();
  const { params, url } = useRouter();
  const { activeProfile, isLoading } = useActiveProfile();
  const user =
    !isLoading && activeProfile
      ? {
          avatarUrl: getGravatarUrl(activeProfile.emailHash),
          name:
            `${activeProfile.firstName ?? ''} ${
              activeProfile.lastName ?? ''
            }`.trim() || activeProfile.email,
        }
      : null;

  const emitEvent = params.id
    ? emitPartnerUserInteractionEvent
    : emitUserInteractionEvent;

  return isLoading ? null : (
    <Header
      ctaLinks={getCtaLinks(emitEvent)}
      currentUrl={url}
      logoUrl={PLATFORM_MARKETING_BASE_URL}
      navLinks={getNavLinks(emitEvent)}
      onClickLogout={() =>
        emitUserEventOptionClicked(emitEvent, 'Log out', 'Log Out', 'log out')
      }
      onClickZapier={() =>
        emitUserEventOptionClicked(
          emitEvent,
          'Navigate to zapier.com',
          'zapier.com',
          'zapier'
        )
      }
      onOpenUserOptions={() =>
        emitEvent(
          {
            eventAction: 'open',
            interactionGoal: 'Open the profile menu',
            interactionName: 'profile_picture_clicked',
            interactionRawText: '',
            optionSelected: '',
          },
          { isTentative: true }
        )
      }
      user={user}
      userLinks={getUserLinks(emitEvent)}
    />
  );
}

export default PlatformHeader;
